// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationEmptyStatePath = 'M53.09 27L54 11h-8l.91 16h6.18zm9.7 26.275l-5.32-4.55L47.082 60.87l-5.095-5.023-4.914 4.986L47.518 71.13 62.79 53.275zM87.83 28.33L75.87 39l-4.37-4.37 10.67-11.96 5.66 5.66zM83.5 63.59l16 .91v-8l-16 .91v6.18zM17.83 22.67L28.5 34.63 24.13 39 12.17 28.33l5.66-5.66zM16.5 57.41l-16-.91v8l16-.91v-6.18zm10.1-12.83a29 29 0 1143.188 38.082c7.271.357 15.612-.863 26.204-4.053l1.465-.45 2.086 6.682c-17.204 5.371-29.456 6.066-40.52 3.262l-.757-.196c-2.613-.694-4.926-1.494-8.317-2.818l-3.468-1.374C39.587 80.99 35.513 79.911 30 79.78c-6.974-.18-15.328 1.546-26.014 5.702l-.7.274-2.572-6.51c9.016-3.562 16.66-5.57 23.391-6.231A29.005 29.005 0 0126.6 44.58zm5.368 28.275a22.001 22.001 0 1127.655 8.168c-2.27-.626-4.407-1.383-7.64-2.655l-3.592-1.423c-6.514-2.542-10.97-3.765-16.423-4.09z';
var IllustrationEmptyState = baseIllustration('IllustrationEmptyState', {
  getPath: () => IllustrationEmptyStatePath
}, 'ColoredIllustrationEmptyState');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationEmptyState;
//# sourceMappingURL=index.js.map